import { useSelector } from "react-redux";
import { selectHasActivePlan } from "../util/planGate";

export const useHasActivePlan = () => useSelector(selectHasActivePlan);
